import { useEffect, useState, useContext } from "react";
import axios from 'axios';

import { UserPlus } from "../../files/icons/index.js";

import { PatientAvatar } from "../components/component.js";
import Drop from "./drop.js";

import { AppContext } from '../../context.js';
import { use } from "react";

import { FullName } from '../../utils/string.js';

function PatientPicker(props) {
  const { patientList, patientID, onChange, onChangeID, leftText, leftIcon, rightIcon, className } = props;

  const context = useContext(AppContext);

  const [loading, setLoading] = useState(true);

  const [patients, setPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const [closePatientDrop, setClosePatientDrop] = useState(0);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!loading) {
      if (patientID) {
        setSelectedPatient(patients.find((p) => p.id === patientID));
      }
      return
    }

    if (patientList) {
      setPatients(patientList.sort((a, b) => a.firstName.localeCompare(b.firstName)));
      if (patientID) {
        setSelectedPatient(patientList.find((p) => p.id === patientID));
      }
      setLoading(false);
      return;
    }

    let u = context.addSpiner();
    axios.post('/api/admin/patients', {
      filter: {}
    }).then((response) => {
      setPatients(response.data.patients.sort((a, b) => a.firstName.localeCompare(b.firstName)));
      if (patientID) {
        setSelectedPatient(response.data.patients.find((p) => p.id === patientID));
      }
      setLoading(false);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, [patientList, patientID]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  function renderPatients() {
    let filteredPatients = patients.filter((patient) => {
      const fullName = FullName(patient.firstName, patient.middleName, patient.lastName).toLowerCase();
      return fullName.includes(searchText.toLowerCase());
    });

    // Filter archived patients out
    filteredPatients = filteredPatients.filter((patient) => (patient.statusType === 'DRAFT' || patient.statusType === 'ACTIVE'));

    if (filteredPatients.length === 0) {
      return (
        <div className="side-item small nowrap">
          <span className="typo-normal-150">No patients found</span>
        </div>
      );
    }

    return filteredPatients.map((patient, i) => {
      return (
        <div className="side-item small nowrap" key={i} onClick={() => { onChange(patient, onChangeID); setClosePatientDrop(closePatientDrop + 1); setSearchText(""); }}>
          <PatientAvatar id={patient.id} />
          <span className="typo-normal-150">{FullName(patient.firstName, patient.middleName, patient.lastName)}</span>
        </div>
      );
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <Drop close={closePatientDrop}>
      <div className={"item grey " + className}>
        {leftIcon && leftIcon}
        {leftText && <span className="typo-normal-150">{leftText}</span>}
        {selectedPatient ? (
          <PatientAvatar id={selectedPatient.id} />
        ) : (
          <UserPlus height={16} width={16} color={'grey'} />
        )}
        <span className="typo-normal-150">{selectedPatient ? FullName(selectedPatient.firstName, selectedPatient.middleName, selectedPatient.lastName) : "Assignee"}</span>
        {rightIcon && rightIcon}
      </div>
      <div className="card shadowmore" style={{minWidth: 180, width: 'fit-content'}}>
        <div className="card-content sm" style={patients.length > 20 ? {height: 300, overflowY: 'auto'} : {}}>
          <input type="text" className="input borderless typo-normal-150 w-100 mb-2" placeholder="Search..." value={searchText} onChange={handleSearchChange} autoFocus={true} />

          {renderPatients()}
        </div>
      </div>
    </Drop>
  );
}

export default PatientPicker;
